// src/components/ForfeitedByMmyyPage.jsx
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useEscapeToGoBack from "../hooks/useEscapeToGoBack";
import "./Renew.css";

const REPORTS_API = "https://www.lianfoong.com/api/reports";

// Validates "MMYY" where MM is 01..12
function isValidMmyy(value) {
  if (!/^\d{4}$/.test(value)) return false;
  const mm = parseInt(value.slice(0, 2), 10);
  return mm >= 1 && mm <= 12;
}

const ForfeitedByMmyyPage = () => {
  useEscapeToGoBack();
  const navigate = useNavigate();
  const [mmyy, setMmyy] = useState("");
  const [downloading, setDownloading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    requestAnimationFrame(() => inputRef.current?.focus());
  }, []);

  const handleChange = (e) => {
    // Keep digits only, max 4 chars
    const digits = e.target.value.replace(/\D/g, "").slice(0, 4);
    setMmyy(digits);
  };

  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    a.remove();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidMmyy(mmyy)) {
      alert("Please enter a valid MMYY (e.g. 1025 for Oct 2025).");
      return;
    }
    setDownloading(true);
    try {
      const resp = await axios.get(`${REPORTS_API}/forfeited.pdf`, {
        params: { mmyy },
        responseType: "blob",
      });
      downloadBlob(resp.data, `forfeited_${mmyy}.pdf`);
    } catch (err) {
      console.error(err);
      alert("Failed to generate report.");
    } finally {
      setDownloading(false);
    }
  };

  const valid = isValidMmyy(mmyy);

  return (
    <div className="renew-container">
      <h2 className="title">Forfeited Tickets</h2>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>MMYY:</label>
          <input
            ref={inputRef}
            type="text"
            inputMode="numeric"
            placeholder="e.g. 1025"
            value={mmyy}
            onChange={handleChange}
            aria-label="MMYY"
          />
          
        </div>

        <button className="search-btn" type="submit" disabled={downloading || !valid}>
          {downloading ? "Generating…" : "Download PDF"}
        </button>

        <button
          type="button"
          className="next-btn"
          onClick={() => navigate(-1)}
          style={{ marginTop: 10 }}
        >
          Back
        </button>
      </form>
    </div>
  );
};

export default ForfeitedByMmyyPage;
